// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/wind-shear-microburst.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/wind-shear-microburst/microburst-characteristics.js';
import g1 from '../lessons/meteorology/wind-shear-microburst/wind-shear-microburst.js';

mount([g0, g1]);
